export const data = {
  latest: {
    v0: 0,
    v1: 0,
    guestSeries_1: [0, 0],
    guestSeries_2: [0, 0],
  },
};
